import { createLucideIcon } from "lucide-react";

export const MoreVerticalCircle = createLucideIcon(
    "MoreVerticalCircle",
    [
        [
            "path",
            {
                d: "M11.9842 16H11.9932",
                key: "1uk0zn",
            },
        ],
        [
            "path",
            {
                d: "M11.9959 12H12.0049",
                key: "9vko0u",
            },
        ],
        [
            "path",
            {
                d: "M11.9998 8H12.0088",
                key: "58284l",
            },
        ],
        [
            "path",
            {
                d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
                key: "170qnq",
            },
        ],
    ],
);
